import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import { Dispatch } from 'redux';
import 'hammerjs';
// Components
import { GetString } from '../StringResourceManager';
import { getTopAssetStateCountsByName } from '../../store/Devices/AssetStatesActions';
import OverviewWidgetChart from '../OverviewWidgetChart';
import { ChartSeriesInterface } from '../../Interfaces/Devices/ChartSeriesInterface';
import { CategorySummary } from '../../Interfaces/Assets/CategorySummary';
import { SeriesClickEvent } from '@progress/kendo-react-charts';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { ASSET } from '../../utils/constants';
import { saveAssetStatusesFilters } from '../../store/UserSettings/UserSettingsActions';
import { ChartColors } from './ChartColors';

export default function TopDeviceIssuesChart() {
  const [refresh, setRefresh] = useState<boolean>(true);

  const categorySummary: CategorySummary[] = useSelector(
    (state: ApplicationState) => state.assetStatusesReducer.categorySummary
  );

  const isFetchingCategorySummary: boolean = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.isFetchingCategorySummary
  );

  const [topFiveDeviceIssues, setTopFiveDeviceIssues] = React.useState<
    string[]
  >([]);

  const [topFiveDeviceIssuesSeriesData, setTopFiveDeviceIssuesSeriesData] =
    React.useState<ChartSeriesInterface[]>([]);

  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
      getTopAssetStateCountsByName(dispatch, 'CurrentIssue', 5);
    }

    return () => {};
  }, [refresh]);

  useEffect((): ReturnType<React.EffectCallback> => {
    processTopFiveDeviceIssuesChartData();
  }, [categorySummary]);

  const maxChartValueAxisItem: any = () => {
    return topFiveDeviceIssuesSeriesData.length > 0
      ? Math.max(...topFiveDeviceIssuesSeriesData[0].count) + 10
      : 10;
  };

  const processTopFiveDeviceIssuesChartData = () => {
    let issues: string[] = [];
    let seriesData: ChartSeriesInterface[] = [
      {
        status: undefined,
        count: [],
        color: ChartColors.Red,
      },
    ];

    for (let i = 0; i < categorySummary.length; ++i) {
      issues.push(
        categorySummary[i].Category + ': ' + categorySummary[i].Value
      );

      seriesData[0].count.push(categorySummary[i].Total);
    }

    setTopFiveDeviceIssues(issues);
    setTopFiveDeviceIssuesSeriesData(seriesData);
  };

  const onDeviceIssueSeriesItemClick = (event: SeriesClickEvent) => {
    let data = event.category.split(': ');
    let filter: CompositeFilterDescriptor = {
      logic: 'and',
      filters: [
        {
          field: ASSET.CURRENT_ISSUE,
          operator: 'eq',
          value: {
            Category: data[0],
            Name: 'CurrentIssue',
            Value: data[1],
          },
        },
      ],
    };

    saveAssetStatusesFilters(dispatch, filter);
  };

  return (
    <OverviewWidgetChart
      chartTitleText={GetString('TOP_DEVICE_ISSUES')}
      chartValueAxisItemtitle={GetString('NUMBER_OF_ISSUES')}
      chartCategoryAxisItem={topFiveDeviceIssues}
      maxChartValueAxisItem={maxChartValueAxisItem()}
      seriesData={topFiveDeviceIssuesSeriesData}
      chartSeriesClick={onDeviceIssueSeriesItemClick}
      chartType="bar"
      goToScreen="devices"
      isRefreshing={isFetchingCategorySummary}
    />
  );
}
